module.exports = __webpack_public_path__ + "static/img/science_1.92ed81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/science_1.png
// module id = 6il0
// module chunks = 15